import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import MobileLinks from './MobileLinks';
import { Cross20Svg } from '../svg';
import reducer from './store';
import { injectReducer } from 'store/index';
import { setMobileMenuState } from './store/dataSlice';
import { setWebLanguage } from '../store/dataslice';

injectReducer('mobileMenu', reducer)

function MobileMenu(props) {
    const { locale } = props;    
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);

    const mobileMenuLinks = [
        {
            pageName: `${GeneralTranslations.report}`,
            url: '/',
            hasChild: false,
            otherSource: false,
        },
        {
            pageName: `${ControlsTranslations.SearchButton}`,
            url: '/Kerko',
            hasChild: false,
            otherSource: false,
        },

    ];


    const dispatch = useDispatch();
    const mobileMenuState = useSelector((state) => state.mobileMenu.data.mobileMenuState);

    const classes = classNames('mobilemenu', {
        'mobilemenu--open': mobileMenuState,
    });

    const handleItemClick = () => {
        dispatch(setMobileMenuState(false));
    };

    const refreshPage = ((lang) => {
        dispatch(setWebLanguage(lang));
        dispatch(setMobileMenuState(false));
    });

    const [activeLanguage, setActiveLanguage] = useState('');

    useEffect(() => {
        setActiveLanguage(WebsiteLanguage);
    }, [WebsiteLanguage])

    return (
        <div className={classes}>

            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
            <div className="mobilemenu__backdrop" onClick={handleItemClick} />
            <div className="mobilemenu__body">
                <div className="mobilemenu__header">
                    <div className="mobilemenu__title">Menu</div>
                    <button type="button" className="mobilemenu__close" onClick={handleItemClick}>
                        <Cross20Svg />
                    </button>
                </div>
                <div className="mobilemenu__content">
                    <MobileLinks links={mobileMenuLinks} onItemClick={handleItemClick} />
                    <div className="mobilemenu__language">
                        <button
                            className={activeLanguage === 'sq' ? 'active mobile-links__item-button' : 'mobile-links__item-button'}
                            type="button"
                            onClick={() => refreshPage('sq')}
                        >
                            SQ
                        </button>
                        <button
                            className={activeLanguage === 'en' ? 'active mobile-links__item-button' : 'mobile-links__item-button'}
                            type="button"
                            onClick={() => refreshPage('en')}
                        >
                            EN
                        </button>
                        <button
                            className={activeLanguage === 'sr' ? 'active mobile-links__item-button' : 'mobile-links__item-button'}
                            type="button"
                            onClick={() => refreshPage('sr')}
                        >
                            SR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;
